import { API_URL } from "config";
import Http from "util/https";
import { CSVUploadOrderParam, CsvUploadOrderAskResponseApi, OrderCheck } from "../types/index";
import { convertUTCToDate, orderStatusFromNumber } from "../utils/common";

// const res: {data: CsvUploadOrderAskResponseApi} = {
//   data: {
//     process_id: "process_id1",
//     total: 15,
//     errors: ["error1"],
//     list: [{
//       order_status: 1,
//       order_build_no: "0001_20250303103010",
//       item_cd: "000001",
//       jan_cd: "0123456789012",
//       store_name: "美女木店",
//       supplier_name: "ﾌﾞﾘﾁﾞｽﾄﾝ",
//       class_name: "タイヤ",
//       brand: "WH",
//       item_name: "WH STA",
//       size: "185/65R15H",
//       maker_item_cd: "-",
//       order_quantity: 1000,
//       unit_base_price: 10000,
//       unit_cost_price: 15000,
//       unit_sale_price: 20000,
//       order_date: "2025-01-01",
//       desired_date: "2025-01-01",
//       shipping_date: "2025-01-01",
//       shipping_scheduled: "2025-01-01",
//       arrival_date: "2025-01-01",
//       client_doc_no: "0123456789012",
//       is_customer_order: true,
//       is_direct: false,
//       memo: "店舗の備考本文です",
//       remarks: "本部の備考本部です",
//       error: "",
//     }]
//   }
// }

/**
 * 注文依頼更新CSV確認Api
 * @param params 注文依頼更新CSV確認Apiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function getCsvOrderAskConfirmApi(params: CSVUploadOrderParam) {
  console.log("params:", {...params, upload_kind: 1});
  const http = Http.default.alterAuth({useToken: true, useFormData: true});
  const url = `${API_URL}/order/product/csv/upload`;
  const res = await http.post<CsvUploadOrderAskResponseApi>(url, Http.convertObjectToFormData({...params, upload_kind: 1}));

  const orders: OrderCheck[] = res.data.order_infos.map((s, i) => {
    const order: OrderCheck = {
      id: i+1,
      orderStatus: 1,  // csv依頼は確認中固定。 orderStatusFromNumber(s.order_status),
      orderNumber: s.order_build_no ?? '',
      productCd: s.item_cd ?? '',
      janCd: s.jan_cd ?? '',
      shopName: s.order_store_name ?? '',
      supplierName: s.supplier_name ?? '',
      classification: s.class_name ?? '',
      brand: s.brand ?? '',
      productName: s.item_name ?? '',
      size: s.size ?? '',
      productNumber: s.maker_item_cd ?? '',
      orderCount: s.order_quantity || 0,
      headquartersCost: (s.unit_base_price * s.order_quantity) || 0,
      headquartersUnitCost: s.unit_base_price || 0,
      wholesalePrice: (s.unit_cost_price * s.order_quantity) || 0,
      wholesaleUnitPrice: s.unit_cost_price || 0,
      shopPrice: (s.unit_sale_price * s.order_quantity) || 0,
      shopUnitPrice: s.unit_sale_price || 0,
      orderDate: convertUTCToDate(s.order_date),
      deliveryDate: convertUTCToDate(s.desired_date),
      shippingDate: convertUTCToDate(s.shipping_date),
      expectedShippingDate: convertUTCToDate(s.shipping_scheduled),
      arrivalDate: s.arrival_date,
      clientBillNumber: s.client_doc_no ?? '',
      isCustomerOrder: s.is_customer_order ?? '',
      isDirectOrder: s.is_direct ?? '',
      shopRemarks: s.memo ?? '',
      headquartersRemarks: s.remarks ?? '',
      error: (s.errors && (s.errors.length > 0)) ? s.errors.join('\n') : (s.error ?? undefined),
    };

    return order;
  });

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res.data);
  console.log('orders:', orders);
  return {
    orders,
    processId: res.data.process_id,
    total: res.data.total,
    // error: (res.data.errors && res.data.errors.length > 0) ? 'エラーがあります。修正してからもう一度アップロードしてください。' : undefined,
    error: (res.data.errors && res.data.errors.length > 0) ? res.data.errors.join('\n').slice(0,100) : undefined,
  };
}
